import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import ContactUsAction from 'app/Components/Shared/ContactUs/ContactUsAction';
import {isMobile} from 'react-device-detect';
import {stepEnum, message, paymentAction} from '../Constants/debtPaymentEnum';
import Image from 'app/Components/Shared/Image/image';
import {
  handleCurrentStep,
  selectSelectedBanData,
  selectPaymentAmount,
  selectPaymentAction,
  selectServerData,
  selectEpiData,
} from '../DebtAndUpdatePaymentBlockSlice';
import {dwhCreditCardPageReport, dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';

const GeneralMessage = ({goToLobby, currentStep}) => {
  const dispatch = useDispatch();
  const [messageData, setMessageData] = useState(null);
  const selectedBanData = useSelector(selectSelectedBanData);
  const paymentAmount = useSelector(selectPaymentAmount);
  const paymentActionType = useSelector(selectPaymentAction);
  const loginData = useSelector((state) => state.authentication.loginData);
  const bansForUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const yDaysCount = useSelector((state) => state.debtAndUpdatePayment.paymentStatusDisplayDaysY);
  const yDaysCountEnergy = useSelector((state) => state.debtAndUpdatePayment.energyPaymentStatusDisplayDaysY);

  useEffect(() => {
    const messageData = message[currentStep];
    if (messageData) {
      setMessageData(messageData);
    }
    //fire only for energy credit card payment failure (GENERALERROR is handled in DebtPayment.js)
    if (currentStep === stepEnum.PAYMENTFAILEDENERGYY) {
      dwhCreditCardPageReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        paymentActionType,
        bansForUpdate,
        actionType:
          paymentActionType === paymentAction.PAYMENT_AND_UPDATE
            ? DwhActionType.PaymentAndUpdateTransaction
            : DwhActionType.PaymentOnlyTransaction,
        messageText: DWHMessageText.GeneralError,
        status: DWHStatus.Error,
        yDaysCount,
        yDaysCountEnergy,
      });
    }
    if (paymentActionType === paymentAction.UPDATE_PAYMENT_METHOD && currentStep === stepEnum.UPDATEPAYMENTFAILEDCC) {
      dwhUpdatePaymentMethodReport({
        banData: selectedBanData,
        loginData,
        allBans,
        selectedBanNumbers: bansForUpdate,
        actionType: DwhActionType.SettingCreditCard,
        messageText: DWHMessageText.GeneralError,
        status: DWHStatus.Error,
        lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
      });
    }
    if (paymentActionType === paymentAction.UPDATE_PAYMENT_METHOD && currentStep === stepEnum.UPDATEPAYMENTFAILEDBANK) {
      dwhUpdatePaymentMethodReport({
        banData: selectedBanData,
        loginData,
        allBans,
        selectedBanNumbers: bansForUpdate,
        actionType: DwhActionType.SettingStandingOrder,
        messageText: DWHMessageText.GeneralError,
        status: DWHStatus.Error,
        lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
      });
    }
  }, []);

  function getButton() {
    if (currentStep === stepEnum.UPDATEPAYMENTFAILEDBANK || currentStep === stepEnum.UPDATEPAYMENTFAILEDCC) {
      return <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={() => dispatch(handleCurrentStep(stepEnum.BANSELECT))} />;
    }
    return <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={goToLobby} />;
  }

  return (
    <div className={`debtpayment-step payment-error-step${currentStep === stepEnum.GENERALERROR ? ' general-error' : ''}`}>
      <div className='payment-error-step__icon'>
        <Image src={messageData?.icon} alt='payment-error' />
      </div>
      <div className='message-content'>
        <div className={` extra ${isMobile ? 'm-title' : 'l-title'}`} dangerouslySetInnerHTML={{__html: messageData?.title}} />
        {messageData?.secondTitle && (
          <div
            className={`${currentStep === stepEnum.PAYMENTFAILEDENERGY ? 's-title-small' : 'm-title'}`}
            dangerouslySetInnerHTML={{__html: messageData?.secondTitle}}
          />
        )}
        {currentStep === stepEnum.UPDATEPAYMENTFAILEDBANK && (
          <div className={`m-title`} dangerouslySetInnerHTML={{__html: epiData.updatePaymentFailedSubTitle}} />
        )}
      </div>
      {currentStep === stepEnum.UPDATEPAYMENTFAILEDBANK && (
        <div className='credit-card-payment-button'>
          <BtnSubmit text={'להגדרת כרטיס אשראי'} onclick={() => dispatch(handleCurrentStep(stepEnum.CREDITCARD))} />
        </div>
      )}
      {messageData?.contactUs && (
        <div className={`${currentStep === stepEnum.UPDATEPAYMENTFAILEDBANK ? 'update-payment-failed' : ''} call-option-container`}>
          {messageData.showContactUsTitle && <div className='s-title-small' dangerouslySetInnerHTML={{__html: 'נשמח לסייע לך'}} />}
          <ContactUsAction contentData={messageData?.contactUs} />
        </div>
      )}
      <div className={`continue-button ${currentStep === stepEnum.UPDATEPAYMENTFAILEDBANK ? 'bank-error' : ''}`}>{getButton()}</div>
    </div>
  );
};

export default GeneralMessage;
